<template>
  <div class="leave">
    <van-nav-bar
      @click-left="clickBack"
      title="进出时段列表"
      right-text="进出申请"
      @click-right="clickNavBarRight"
      left-arrow
    >
    </van-nav-bar>
    <div class="leave-list-wrap">
      <div class="leave-list-title">进出时段申请列表</div>
      <div class="leave-list" v-if="list.length > 0">
        <div
          class="leave-list-item"
          v-for="item in list"
          :key="item.id"
          @click="clickLeaveDetail(item)"
        >
          <div class="cause flex flex-b flex-vc">
            <div>
              <span
                v-for="(v, index) in item.childDTOS"
                :key="index"
                style="margin-right: 0.5rem;"
                >{{ v.name }}
                <span style="color: #999; font-size: 0.75rem;">{{
                  v.className
                }}</span>
                <span
                  v-if="
                    item.childDTOS.length > 0 &&
                      index !== item.childDTOS.length - 1
                  "
                  >、</span
                >
              </span>
            </div>
            <van-tag plain type="success" v-if="item.leaveState == 1"
              >已同意</van-tag
            >
            <van-tag plain type="primary" v-if="item.leaveState == 0"
              >待审批</van-tag
            >
            <van-tag plain type="danger" v-if="item.leaveState == 2"
              >已拒绝</van-tag
            >
          </div>
          <!-- <div class="date">
            <span
              >{{ item.leaveTime }} {{ item.leaveBeginTime }} -
              {{ item.leaveEndTime }}</span
            >
          </div> -->

          <div class="date">
            <span>开始时间：</span
            ><span>{{ item.leaveTime }} {{ item.leaveBeginTime }}</span>
          </div>
          <div class="date">
            <span>结束时间：</span
            ><span>{{ item.leaveTime }} {{ item.leaveEndTime }}</span>
          </div>
          <div class="date">
            <span>申请原因：</span>
            <span>{{ item.remark }}</span>
          </div>
          <!--  <div class="date">
           <span
              style="width: 3.7rem; display: inline-block; text-align: right;"
              >原因：</span
            ><span>{{ item.remark }}</span>
          </div> -->
        </div>
      </div>
      <div class="" v-if="list.length <= 0">
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
    }
  },
  mounted() {
    this.getList()
  },
  computed: {
    personType() {
      return JSON.parse(localStorage.getItem('userInfo')).personType
    },
  },
  methods: {
    clickBack() {
      this.$router.go(-1)
    },
    clickNavBarRight() {
      this.$router.push('/accessForm')
    },
    clickLeaveDetail(item) {
      this.$router.push({
        path: '/accessDetail',
        query: { ...item, type: 'list' },
      })
    },
    getList() {
      this.list = []
      Promise.all([
        this.getAccessList(0),
        this.getAccessList(1),
        this.getAccessList(2),
      ]).then((res) => {
        console.log(res)
        // res.forEach((item) => {
        //   this.list.push(item)
        // })
        res.forEach((item) => {
          item.forEach((v) => {
            this.list.push(v)
          })
        })
      })
    },
    // 0 未审批 1已审批 2驳回
    async getAccessList(state) {
      const { data, code } = await this.$https.getAccessList({
        status: state,
        personType: this.personType,
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
      })
      if (code !== 200) {
        return false
      }
      return Promise.resolve(data)
    },
  },
}
</script>

<style lang="scss" scoped>
.leave-list-wrap {
  .leave-list-title {
    padding: 1rem;
  }
  .leave-list {
    border-radius: 0.75rem;
    border-radius: 1.0625rem;
    margin: 0 1rem;
    box-shadow: 0rem 1rem 1rem rgba(69, 91, 99, 0.1);
    overflow: hidden;
    .leave-list-item {
      display: flex;
      flex-direction: column;
      padding: 0.75rem;

      background: #fff;
      font-size: 0.75rem;
      color: rgba(120, 132, 158, 1);
      border-bottom: 1px solid #f4f4f6;

      .cause {
        font-size: 1rem;
        font-weight: bold;
        color: #333;
        margin-bottom: 0.55rem;
        .status {
          color: #1989fa;
          font-size: 0.85rem;
        }
      }
      .date {
        margin-bottom: 0.55rem;
      }
    }
  }
}
</style>
